import { defineMessages } from 'react-intl';

export const agentMcpCapabilitiesWarningMessages = defineMessages({
  capabilities: {
    id: 'oauth.mcp.agent.capabilitiesWarning',
    defaultMessage:
      'Let AI agents chat with {agentName} and use its skills to read, create or delete content on your behalf.',
    description:
      'Static all-or-nothing capability warning for Agent MCP consent; {agentName} is the custom agent receiving access',
  },
});
